
import { InfoList } from "../../types/infoLists";

type Props = {
  infolist: InfoList;
};

export default function InfoListWidget({ infolist }: Props) {
  return (
    <div className="mt-16">
      <h3 className="text-xs font-light uppercase tracking-widest text-white">
        {infolist.header}
      </h3>
      <ul className="relative z-20 mt-4 space-y-2 font-light text-white">
        {infolist.list.map((item, index) => (
          <li className="hover:text-violet-300">
            <a href={item.link} target="_blank" rel="noreferrer">
              {item.preLabel ?? `00${index + 1} `}
              {' '} ----- {' '}
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
